export enum MileageRange {
  under25 = 'under25',
  under50 = 'under50',
  under75 = 'under75',
  under100 = 'under100',
  under125 = 'under125',
  under150 = 'under150',
  under175 = 'under175',
  under200 = 'under200',
}

export const MileageRangeValues: { [key in MileageRange]: string } = {
  under25: 'Under 25,000',
  under50: 'Under 50,000',
  under75: 'Under 75,000',
  under100: 'Under 100,000',
  under125: 'Under 125,000',
  under150: 'Under 150,000',
  under175: 'Under 175,000',
  under200: 'Under 200,000',
};
